import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./utils.service";
export class BoatInscriptionService extends BaseProvider {
    constructor(globals, http, utils) {
        super();
        this.globals = globals;
        this.http = http;
        this.utils = utils;
        this.dataSource = [];
        this.ticketDataSource = [];
        this.fineList = [];
        this.baseUrl = 'maritime';
    }
    getBoat(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/id/' + params.ssn + '/register/' + params.regNum;
            // 'https://ws.drna.pr.gov/xuvoapi/serv/getshipown/' + 
            //            '?id=' + params.ssn + 
            //            '&registro=' + params.regNum  + 
            //            '&NEPTUNO_ACC_KEY=12345';      
            this.http.get(this.url).subscribe((data) => {
                console.log(data);
                resolve(data);
            }, (err) => {
                console.log(err);
                this.dataSource = [];
                reject(err);
            });
        });
    }
    getFines(params) {
        return new Promise((resolve, reject) => {
            this.url = this.url = this.globals.dataUrl + this.baseUrl + '/register/' + params.regNum + '/process/' + params.userProcessId;
            // 'https://ws.drna.pr.gov/xuvoapi/serv/gettickets/' + 
            // '?&registro=' + params.regNum  + 
            // '&NEPTUNO_ACC_KEY=12345';      
            this.http.get(this.url).subscribe((data) => {
                console.log(data);
                resolve(data);
            }, (err) => {
                this.ticketDataSource = [];
                reject(err);
            });
        });
    }
    getUserProcessFineAssociation(userProcessId) {
        return new Promise((resolve, reject) => {
            this.url = this.url = this.globals.dataUrl + this.baseUrl + '/process/' + userProcessId;
            this.http.get(this.url).subscribe((data) => {
                console.log(data);
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    saveBoats(data) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http
                .post(this.url, data)
                .subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getFinesPayed(processId) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/finesPayed/process/${processId}`;
            this.http.get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
}
BoatInscriptionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BoatInscriptionService_Factory() { return new BoatInscriptionService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.UtilsService)); }, token: BoatInscriptionService, providedIn: "root" });
